<template>
  <div class="auth-fields">
    <InputField
      class="input-field_form"
      placeholder="Ваш Email"
      type="email"
      :required="true"
      :errors="props.errors.email"
      @input="email = $event"
      :debounceWait="0"
    />
    <InputField
      class="input-field_form"
      placeholder="Введите пароль"
      type="password"
      :required="true"
      :errors="props.errors.password"
      @input="password = $event"
      :debounceWait="0"
    />
    <!-- <div
      class="captcha"
    >
      <InputField
        class="input-field_form"
        placeholder="Введите код с картинки"
        type="number"
        :required="true"
        :errors="props.errors.captcha"
        @input="captcha = $event"
        :debounceWait="0"
      />
      <img
        class="captcha__pic"
        :src="`http://212.193.59.184//captcha?${8999 * Math.random() + 1E3}`"
        alt="Капча"
      >
    </div> -->
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import InputField from './InputField.vue';

const props = defineProps({
  errors: Object,
});

const emit = defineEmits(['updatedData']);

const email = ref(null);
const password = ref(null);

watch([email, password], () => {
  emit('updatedData', {
    email: email.value,
    password: password.value,
    captcha: 'stub',
  });
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/input.scss';
@import '@/assets/scss/auth-fields.scss';
</style>
